import classNames from "classnames";
import { v4 as uuid } from "uuid";
import {get, uniqueId} from "lodash";
import {
  EMPTY_STRING,
  EMPTY_ARRAY,
  DATA_TYPES,
  INDEX,
} from "../../../constants";
const { FIRST } = INDEX;
const MAX_LENGTH = 35;

const renderFormatter = ({ formatter, text }) => {
  return (
    <>
      <div className="flex space-x-2 ml-3">
        <span className="inline-block space-x-2">{formatter} </span>
        <span className="inline-block space-x-2">{text} </span>
      </div>
    </>
  );
};

const renderCustomModelData = (row, dataField) => {
  const rowData = get(row, dataField, EMPTY_STRING);
  if (typeof rowData === DATA_TYPES.STRING && rowData.length > MAX_LENGTH)
    return rowData.slice(FIRST, MAX_LENGTH) + "...";
  return rowData;
};

const Table = ({
  data = EMPTY_ARRAY,
  columns = EMPTY_ARRAY,
  footer,
  onRowClick,
  isCustomModelData = false,
}) => (
  <div
    className={classNames("border overflow-auto scrollbar border-gray-600 rounded-lg", {
      "max-h-96": footer,
    })}
  >
    <table className="table text-gray-50 w-full border-collapse">
      <thead className="bg-gray-900 top-0 z-10">
        <tr className="border-b border-gray-600 text-left">
          {columns.map((column) => (
            <th
              key={uuid()}
              className={classNames(
                "px-6 py-3 text-xs font-medium tracking-wider uppercase first:rounded-tl-lg last:rounded-tr-lg border-r border-gray-600 last:border-none",
                column.className
              )}
            >
              {column.headerFormatter
                ? renderFormatter({
                    formatter: column.headerFormatter(data),
                    text: column.text,
                  })
                : column.text}
            </th>
          ))}
        </tr>
      </thead>
      <tbody className="divide-y divide-gray-600 bg-gray-800">
        {!data.length ? (
          <tr>
            <td
              className="py-6 px-8 text-center rounded-b-lg"
              colSpan={columns.length}
            >
              <b>No Data to display</b>
            </td>
          </tr>
        ) : (
          data.map((row, i) => (
            <tr
              key={uniqueId()}
              className={classNames({ "cursor-pointer": onRowClick })}
              onClick={() => onRowClick && onRowClick(row)}
            >
              {columns.map((column) => {
                return (
                  <td
                    key={uuid()}
                    className={classNames(
                      "px-6 py-4 text-sm font-medium border-r border-gray-600 last:border-none whitespace-pre",
                      column.className,
                      {
                        "first:rounded-bl-lg last:rounded-br-lg":
                          data.length - 1 === i,
                      }
                    )}
                    width={column.width || null}
                  >
                    {(!column.dataField && column.formatter(row)) ||
                      (column.formatter &&
                        column.dataField &&
                        renderFormatter({
                          formatter: column.formatter(row),
                          text: get(row, column.dataField, EMPTY_STRING),
                        })) ||
                      (isCustomModelData &&
                        renderCustomModelData(row, column.dataField)) ||
                      get(row, column.dataField, EMPTY_STRING)}
                  </td>
                );
              })}
            </tr>
          ))
        )}
      </tbody>
      {footer}
    </table>
  </div>
);

export default Table;
